"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _scrunchieArrangement = require("@/api/scrunchieArrangement/scrunchieArrangement");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Individuation',
  data: function data() {
    return {
      isEditor: false,
      // 记录是否编辑
      ruleForm: {
        // appId: 2,
        authorIcon: '',
        // 	作者头像
        authorName: '',
        // 作者名称
        shareButtonBackgroundColor: '',
        // 分享按钮背景颜色
        shareButtonBackgroundTextColor: '',
        // 	分享按钮字体色
        id: null
      },
      rules: {
        authorIcon: [{
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '请上传图片',
          trigger: 'blur'
        }],
        authorName: [{
          required: true,
          message: '请输入小编昵称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '请输入小编昵称',
          trigger: 'blur'
        }],
        shareButtonBackgroundColor: [{
          required: true,
          message: '请输入小编昵称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '请输入小编昵称',
          trigger: 'blur'
        }],
        shareButtonBackgroundTextColor: [{
          required: true,
          message: '请输入小编昵称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 500,
          message: '请输入小编昵称',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.isEditor = false;
    this.getMaterialBaseConfigApi();
  },
  methods: {
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (!_this.isEditor) {
            _this.saveMaterialBaseConfigApi();
          } else {
            _this.updateMaterialBaseConfigApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.ruleForm.authorIcon = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    // 查询
    getMaterialBaseConfigApi: function () {
      var _getMaterialBaseConfigApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, data, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context2.n = 1;
              return (0, _scrunchieArrangement.getMaterialBaseConfigApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                data = res.data;
                if (data) {
                  this.isEditor = true;
                }
                this.ruleForm.appId = data.appId;
                this.ruleForm.authorIcon = data.authorIcon;
                this.ruleForm.authorName = data.authorName;
                this.ruleForm.shareButtonBackgroundColor = data.shareButtonBackgroundColor;
                this.ruleForm.shareButtonBackgroundTextColor = data.shareButtonBackgroundTextColor;
                this.ruleForm.id = data.id;
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getMaterialBaseConfigApi() {
        return _getMaterialBaseConfigApi2.apply(this, arguments);
      }
      return getMaterialBaseConfigApi;
    }(),
    //  保存
    saveMaterialBaseConfigApi: function () {
      var _saveMaterialBaseConfigApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context3.n = 1;
              return (0, _scrunchieArrangement.saveMaterialBaseConfigApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '保存成功'
                });
                this.getMaterialBaseConfigApi();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function saveMaterialBaseConfigApi() {
        return _saveMaterialBaseConfigApi2.apply(this, arguments);
      }
      return saveMaterialBaseConfigApi;
    }(),
    // 编辑
    updateMaterialBaseConfigApi: function () {
      var _updateMaterialBaseConfigApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context4.n = 1;
              return (0, _scrunchieArrangement.updateMaterialBaseConfigApi)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
                this.getMaterialBaseConfigApi();
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function updateMaterialBaseConfigApi() {
        return _updateMaterialBaseConfigApi2.apply(this, arguments);
      }
      return updateMaterialBaseConfigApi;
    }()
  }
};